import { AppPageContentWrapper, CircularTextLoader, PageContentBox, THUNK_STATUS } from "@duosoftbg/nacid-components";
import { Box } from "@mui/material";
import React, { useEffect } from "react";
import useAppSelector from "../../../../hooks/redux/base/useAppSelector";
import useAppDispatch from "../../../../hooks/redux/base/useAppDispatch";
import ServiceStepper from "../common/stepper/ServiceStepper";
import { fetchLoggedUserDetails } from "../../../../store/redux/slice/AppData/loggedUser";
import { resetSeAdditionalDocRequest } from "../../../../store/redux/slice/Forms/seAdditionalDocForm";

const SeAdditionalDocNew = () => {
  const dispatch = useAppDispatch();

  const seAdditionalDocForm = useAppSelector((state) => {
    return state.Forms.SeAdditionalDocForm;
  });

  useEffect(() => {
    dispatch(resetSeAdditionalDocRequest());
    dispatch(fetchLoggedUserDetails());
  }, [dispatch]);

  return (
    <AppPageContentWrapper>
      <PageContentBox>
        <Box sx={{ width: "100%" }}>
          {seAdditionalDocForm.dataStateStatus === THUNK_STATUS.INITIAL ? (
            <ServiceStepper
              serviceSteps={seAdditionalDocForm.steps}
              applicationSubtype={"SECONDARY_ADDITIONAL_DOCUMENTS"}
            />
          ) : (
            <CircularTextLoader />
          )}
        </Box>
      </PageContentBox>
    </AppPageContentWrapper>
  );
};

export default SeAdditionalDocNew;
